import { makeAutoObservable } from "mobx";
import { onError } from "@/utils/onError";
import { TableSelectStore } from "@/components/TableSelect/TableSelectStore";
import { DataTableStore } from "./DataTableStore";
import { SearchFilter } from "@/components/filters";
export class SingleVehicleModelStore {
    constructor(vehicleModelService, vehicleManufacturerService) {
        this.vehicleModelService = vehicleModelService;
        this.vehicleManufacturerService = vehicleManufacturerService;
        this.vehicleModel = null;
        this.loading = false;
        this.vehicleManufacturerSelectStore = null;
        makeAutoObservable(this);
    }
    setVehicleModel(vehicleModel) {
        this.vehicleModel = vehicleModel;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setVehicleManufacturerSelectStore(vehicleManufacturerSelectStore) {
        this.vehicleManufacturerSelectStore = vehicleManufacturerSelectStore;
    }
    async init(vehicleModelId) {
        this.setLoading(true);
        try {
            const vehicleModels = vehicleModelId
                ? await this.vehicleModelService.getVehicleModelsByIds([vehicleModelId])
                : null;
            this.setVehicleModel(vehicleModels?.[0] || null);
            this.setVehicleManufacturerSelectStore(new TableSelectStore(new DataTableStore({
                dataLoader: {
                    loadData: (params) => this.vehicleManufacturerService.getVehicleManufacturersWithParams(params),
                },
            }), {
                dataLoader: () => this.vehicleModel
                    ? this.vehicleManufacturerService.getVehicleManufacturersByIds([
                        this.vehicleModel.manufacturerId,
                    ])
                    : Promise.resolve([]),
            }, [
                {
                    id: "vehicle-manufacturer-search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по названию производителя автомобиля...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.vehicleManufacturerSelectStore?.filterStore?.updateFilter("search", value),
                    },
                    visible: true,
                    order: 1,
                },
            ]));
        }
        catch (error) {
            onError(error, "Error initializing vehicle model");
        }
        finally {
            this.setLoading(false);
        }
    }
    async saveVehicleModel(vehicleModelData) {
        try {
            this.setLoading(true);
            const task = this.vehicleModel
                ? this.vehicleModelService.updateVehicleModel(this.vehicleModel.id, vehicleModelData)
                : this.vehicleModelService.createVehicleModel(vehicleModelData);
            this.setVehicleModel(await task);
            return this.vehicleModel;
        }
        catch (error) {
            onError(error, "Error saving vehicle model");
            return null;
        }
        finally {
            this.setLoading(false);
        }
    }
    async deleteVehicleModel(vehicleModelId) {
        this.setLoading(true);
        try {
            await this.vehicleModelService.deleteVehicleModel(vehicleModelId);
            this.setVehicleModel(null);
        }
        catch (error) {
            onError(error, "Failed to delete vehicle model");
        }
        finally {
            this.setLoading(false);
        }
    }
    clearVehicleModelData() {
        this.setVehicleModel(null);
        this.setLoading(false);
    }
}
